import { useMemo } from 'react';

import type { CommentInlineResolveProperties } from '@confluence/inline-comments-queries/entry-points/ActiveInlineCommentsQuery.ts';
import type { FooterResolvedProperties } from '@confluence/comments-panel-queries/entry-points/ActiveCommentsQuery.ts';

export enum CommentStatus {
	OPEN = 'OPEN',
	RESOLVED = 'RESOLVED',
	REOPENED = 'REOPENED',
}

interface UseGetCommentStatusProps {
	resolveProperties?: CommentInlineResolveProperties | FooterResolvedProperties;
}

export const useGetCommentStatus = ({
	resolveProperties,
}: UseGetCommentStatusProps): CommentStatus => {
	return useMemo(() => {
		// If no resolve properties, the comment is open
		if (!resolveProperties) {
			return CommentStatus.OPEN;
		}

		// If resolved is false, the comment is reopened
		if (!resolveProperties.resolved) {
			return CommentStatus.REOPENED;
		}

		return CommentStatus.RESOLVED;
	}, [resolveProperties]);
};
